module.exports = __webpack_public_path__ + "img/collectPayment.0e522b7b.svg";